import { render } from "./SerialEnd.vue?vue&type=template&id=50ad3ccc"
import script from "./SerialEnd.vue?vue&type=script&lang=js"
export * from "./SerialEnd.vue?vue&type=script&lang=js"
script.render = render

export default script